module.exports = __webpack_public_path__ + "static/media/campus-virtual-02.1ab7f04e.svg";